import types from "./types"
import { memberService } from "./memberService"
import { sessionService } from "../session/sessionService"

export default {
  memberLogin,
  memberRegister,
  getMyBookings,
  forgotPassword,
  getProfile,
  updateProfile,
  getEmployeeInfo,
  retrieveBooking,
  checkStaffTicketAllowance,
  activate,
  validateResetToken,
  resetPassword,
}

function memberLogin(userName, password) {
  return dispatch => {
    dispatch(initState());
    return memberService.login(userName, password);
  }
}

function memberRegister(data) {
  return dispatch => {
    dispatch(initState());
    return memberService.register(data);
  }
}

function getMyBookings(forceRefresh) {
  return (dispatch, getState) => {

    if(!forceRefresh) {
      const state = getState()
      const bookings = state.member.myBookings
      if(bookings && bookings.length > 0) {
        return Promise.resolve(bookings)
      }
    }

    return memberService.getMyBookings().then(response => {
      dispatch(getMyBookingsResponse(response));
      return response;
    });
  }
}

function forgotPassword(email) {
  return dispatch => {
    dispatch(initState());
    return memberService.forgotPassword(email);
  }
}

function validateResetToken(data, errorHandler) {
  return dispatch => {
    dispatch(initState());
    return memberService.validateResetToken(data, errorHandler);
  }
}

function resetPassword(data, errorHandler) {
  return dispatch => {
    dispatch(initState());
    return memberService.resetPassword(data, errorHandler);
  }
}

function getProfile() {
  return () => memberService.getProfile().then(profile => {  
    if (profile.contact && profile.customer) {
      const user = {
        title: profile.customer.title,
        firstName: profile.customer.firstName,
        lastName: profile.customer.lastName,
        dateOfBirth: profile.customer.dateOfBirth,
        mobile: profile.contact.mobile,
        email: profile.contact.email,
        country: profile.contact.country,
      }
      sessionService.setPassengerData(user)
    }

    return profile;
  });
}

function retrieveBooking(pnr) {
  return () => memberService.retrieveBooking(pnr)
}

function activate(token, errorHandler) {
  return () => memberService.activate(token, errorHandler)
}

function getEmployeeInfo() {
  return (dispatch) => {
    return memberService.getEmployeeInfo().then(response => {
      dispatch(getEmployeeInfoResponse(response));
      return response;
    });
  }
}

function updateProfile(data) {
  return () => memberService.updateProfile(data)
}

function checkStaffTicketAllowance() {
  return () => memberService.checkStaffTicketAllowance()
}

function initState() {
  return {
    type: types.INIT_STATE
  }
}

function getMyBookingsResponse(payload) {
  return {
    type: types.GET_MY_BOOKINGS_RESPONSE,
    payload,
  }
}

function getEmployeeInfoResponse(payload) {
  return {
    type: types.GET_EMPLOYEE_INFO_RESPONSE,
    payload,
  }
}
